import { combineReducers } from 'redux';
import { filterActions } from 'redux-ignore';

import errorReducer from './handler/errorReducer';
import ErrorTypes from './handler/ErrorTypes';

import layoutReducer from './layout/layoutReducer';
import LayoutTypes from './layout/LayoutTypes';

import sessionReducer from './session/sessionReducer';
import SessionTypes from './session/SessionTypes';

import localeReducer from './locale/localeReducer';
import LocaleTypes from './locale/LocaleTypes';

import routeReducer from './route/routeReducer';
import RouteTypes from './route/RouteTypes';

import notificationReducer from './notification/notificationReducer';
import NotificationTypes from './notification/NotificationTypes';

import scrollbarReducer from './scrollbar/scrollbarReducer';
import * as ScrollbarActionTypes from './scrollbar/scrollbarActionTypes';

import accountReducer from './account/accountReducer';
import AccountTypes from './account/AccountTypes';

import dataReducer from './data/dataReducer';
import DataTypes from './data/DataTypes';

import messageReducer from './message/messageReducer';
import MessageTypes from './message/MessageTypes';

import dashboardReducer from './dashboard/dashboardReducer';
import DashboardTypes from './dashboard/DashboardTypes';

import disclosureReducer from './disclosure/disclosureReducer';
import DisclosureTypes from './disclosure/DisclosureTypes';

import companyReducer from './company/companyReducer';
import CompanyTypes from './company/CompanyTypes';

import uploadReducer from './upload/uploadReducer';
import UploadTypes from './upload/UploadTypes';

import { reducer as formReducer, actionTypes as FormTypes } from 'redux-form';

const rootReducer = combineReducers({
  error: filterActions(errorReducer, Object.values(ErrorTypes)),
  layout: filterActions(layoutReducer, Object.values(LayoutTypes)),
  session: filterActions(sessionReducer, Object.values(SessionTypes)),
  locale: filterActions(localeReducer, Object.values(LocaleTypes)),
  route: filterActions(routeReducer, Object.values(RouteTypes)),
  notification: filterActions(notificationReducer, Object.values(NotificationTypes)),
  scrollbar: filterActions(scrollbarReducer, Object.values(ScrollbarActionTypes)),
  form: filterActions(formReducer, Object.values(FormTypes)),
  account: filterActions(accountReducer, Object.values(AccountTypes)),
  data: filterActions(dataReducer, Object.values(DataTypes)),
  message: filterActions(messageReducer, Object.values(MessageTypes)),
  dashboard: filterActions(dashboardReducer, Object.values(DashboardTypes)),
  disclosure: filterActions(disclosureReducer, Object.values(DisclosureTypes)),
  company: filterActions(companyReducer, Object.values(CompanyTypes)),
  upload: filterActions(uploadReducer, Object.values(UploadTypes))
});

export default rootReducer;
